import React from 'react';
import buildContext from '~/components/jsx-helpers/build-context';
import { IntlProvider } from 'react-intl';
import English from '~/lang/en';
import Spanish from '~/lang/es';
function useContextValue() {
    var _a;
    const [language, setLanguage] = React.useState(((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('oswebLanguage')) || 'en');
    // Copy it to localStorage for later defaulting
    React.useEffect(() => { var _a; return (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem('oswebLanguage', language); }, [language]);
    return { language, setLanguage };
}
const { useContext, ContextProvider } = buildContext({ useContextValue });
function ReactIntlUsingLanguage({ children }) {
    const { language } = useContext();
    const messages = React.useMemo(() => {
        switch (language) {
            case 'es':
                return Spanish;
            default:
                return English;
        }
    }, [language]);
    return (React.createElement(IntlProvider, { locale: language, messages: messages }, children));
}
function WrapReactIntl({ children }) {
    return (React.createElement(ContextProvider, null,
        React.createElement(ReactIntlUsingLanguage, null, children)));
}
export { useContext as default, WrapReactIntl as LanguageContextProvider };
